import GroceryForm from "./GroceryForm/GroceryForm";
import GroceryList from "./GroceryList/GroceryList";
import styles from "./Groceries.module.css";
import Reply from "../UI/Reply";
import { useDispatch, useSelector } from "react-redux";
import GroceryItem from "./GroceryList/GroceryItem";
import { useCallback } from "react";
import { itemsActions } from "../../store/itemStore";

const Groceries = () => {
  const dispatch = useDispatch();
  const groceryItems = useSelector((state) => state.items.groceryItems);
  const isEditing = useSelector((state) => state.items.isEditing);
  const editDetails = useSelector((state) => state.items.editDetails);
  const clearItemsHandler = useCallback(() => {
    dispatch(itemsActions.onSaveGroceryItems([]));
    dispatch(
      itemsActions.onChangeReply({
        type: "success",
        message: "All Items deleted successfully",
      })
    );
  }, [dispatch]);

  return (
    <section className={styles.groceries_container}>
      <Reply />
      <h1 className={styles.grocery_header}>Grocery Bud</h1>
      <GroceryForm />
      {isEditing && <GroceryItem {...editDetails} />}
      {!isEditing && (
        <>
          <GroceryList />
          {groceryItems.length > 0 && (
            <button onClick={clearItemsHandler} className={styles.clear_items}>
              Clear Items
            </button>
          )}
        </>
      )}
    </section>
  );
};

export default Groceries;
